/* eslint-disable class-methods-use-this */
import PCLNAnalytics from '@pcln/analytics'
import { ANALYTICS_CATEGORY_PACKAGES } from '@/constants/analytics'

class Analytics {
  // Log to both GA and Splunk
  fireEvent({
    category = ANALYTICS_CATEGORY_PACKAGES,
    action = '',
    data = '',
    event = '',
    label = ''
  }) {
    PCLNAnalytics.logEvent({
      action,
      category,
      data,
      event,
      label
    })
  }

  // Log an error
  // sample query 'index=cheetah sourcetype=ESBROWSEREVENTDATA_ESSVCS action=Error'
  logError({ message = '' }) {
    PCLNAnalytics.logError({
      message
    })
  }

  // Log directly to Splunk
  // sample query 'index=cheetah sourcetype=ESBROWSEREVENTDATA_ESSVCS action=Log'
  log({ message = '' }) {
    PCLNAnalytics.log({
      message
    })
  }

  // Log a warning
  // sample query 'index=cheetah sourcetype=ESBROWSEREVENTDATA_ESSVCS action=warning'
  logWarning({ name = '', message = '' }) {
    PCLNAnalytics.logWarning({
      name,
      message
    })
  }
}

export default new Analytics()
